import { render } from "./BankCompany.vue?vue&type=template&id=280c869d&scoped=true"
import script from "./BankCompany.vue?vue&type=script&lang=js"
export * from "./BankCompany.vue?vue&type=script&lang=js"

import "./BankCompany.vue?vue&type=style&index=0&id=280c869d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280c869d"]])

export default __exports__